import { createAsyncThunk } from '@reduxjs/toolkit';

import { getApiErrorMessage } from '../lib/getApiErrorMessage';
import { CustomListDetail } from '../types/CustomListSchema';

import type { ThunkConfig } from 'app/providers/StoreProvider/config/types';

interface FetchCustomListDetailParams {
    listId: string;
}

export const fetchCustomListDetail = createAsyncThunk<
    CustomListDetail,
    FetchCustomListDetailParams,
    ThunkConfig<string>
>('customList/fetchCustomListDetail', async ({ listId }, thunkApi) => {
    const { extra, rejectWithValue } = thunkApi;

    try {
        const response = await extra.api.get<CustomListDetail>(
            `/v1/custom-lists/${listId}`,
        );

        return response.data;
    } catch (e) {
        return rejectWithValue(String(getApiErrorMessage(e)));
    }
});
